(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/context/fullscreen-widget-context.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/context/fullscreen-widget-context.js');

'use strict';

const FullscreenWidgetContext = React.createContext();
const FullscreenWidgetProvider = _ref => {
  let {
    children
  } = _ref;
  const [showFullscreen, setShowFullscreen] = React.useState(false);
  const openFullscreen = () => {
    setShowFullscreen(true);
  };
  const closeFullscreen = () => {
    setShowFullscreen(false);
  };
  const value = {
    showFullscreen,
    openFullscreen,
    closeFullscreen
  };
  return React.createElement(FullscreenWidgetContext.Provider, {
    value: value
  }, children);
};
const useFullscreenWidget = () => {
  const context = React.useContext(FullscreenWidgetContext);
  if (!context) {
    return {
      showFullscreen: false,
      openFullscreen: () => {},
      closeFullscreen: () => {}
    };
  }
  return context;
};
setGlobal('svs.eurojackpot.react.context', {
  FullscreenWidgetProvider,
  useFullscreenWidget
});

 })(window);